import { createAction } from 'typesafe-actions';
import { ICardsMap, IDrawResultPoints } from 'widgets/DrawResult/types';
import { ACTIONS } from './types';

export const saveDrawResultToStoreAction = createAction(ACTIONS.SAVE_DRAW_RESULT_TO_STORE)<{
  cards: ICardsMap;
  points: IDrawResultPoints;
}>();

export const resetDrawResultToStoreAction = createAction(ACTIONS.RESET_DRAW_RESULT_TO_STORE)();
